module.exports = __webpack_public_path__ + "img/personal-info-red.df2792d3.svg";